function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3E4C57",
  fillRule: "evenodd",
  d: "M.501-.004l1.363.005a1 1 0 0 1 .98.826l1.57 8.852a1 1 0 0 0 .985.826h7.666a1 1 0 0 1 1 1v1.004a.5.5 0 0 1-.5.5h-2.101l1.529 6.415.005.027a.47.47 0 0 1-.381.546.53.53 0 0 1-.608-.4l-.619-2.593H3.922l-.618 2.593a.53.53 0 0 1-.607.4.47.47 0 0 1-.382-.546l.005-.027 1.529-6.415h-.218a2 2 0 0 1-1.977-1.696L.005.572a.5.5 0 0 1 .496-.576zm10.651 16.009l-.713-2.996H4.874l-.714 2.996h6.992z"
});

var SvgRoom = function SvgRoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/room.679637d6.svg";
export { ForwardRef as ReactComponent };